<template>
	<div>
		<div v-if="!userLoan">
			اطلاعات کامل نمی باشد
		</div>
		<div style="direction: rtl;" v-else>
			<div style="text-align: center;margin-bottom: 10px;font-size: 13pt;position: relative;">
				فروش اقساطی {{ businessTitle }}
			</div>
			<table style="border-collapse: collapse;width: 100%;margin-top: 10px;margin-bottom: 10px;border:1px solid #000;">
				<thead>
					<tr>
						<th style="width: 23%;padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">شماره و عنوان قرارداد</th>
						<th style="width: 20%;padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">نام و نام خانوادگی</th>
						<th style="width: 12%;padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ قرارداد</th>
						<th style="width: 8%;padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تعداد اقساط</th>
						<th style="width: 12%;padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">مبلغ قسط</th>
						<th style="width: 25%;padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">شماره کارت بانک رسالت کارگشا</th>
					</tr>
				</thead>
				<tbody>
					<tr style="">
						<td style="padding: 3px 3px;border-left: 1px solid #000;">
							<div style="text-align: center;font-size: 10pt;display: flex;height:100%">
								<div style="border-left: 1px dashed #ccc;min-width: 30px;padding: 0 2px;margin-left: 3px;">{{ String(userLoan.code).toPersianDigits() }}</div>
								<div style="font-size: 10px;">({{ userLoan.loanModel.title }})</div>
							</div>
						</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">{{ userLoan.memberModel.fullName }}</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">{{ userLoan.startDate_Persian.date.toPersianDigits() }}</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">{{ String(userLoan.month).toPersianDigits() }}</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">{{ String(userLoan.installment).toPriceFormat().toPersianDigits() }}</td>
						<td style="padding: 3px;text-align: center;font-size: 10pt;border-left: 1px solid #000;">{{ '5041-7211-1224-6492'.toPersianDigits() }}</td>
					</tr>
				</tbody>
			</table>

			<div style="min-height:275px">
				<table style="border-collapse: collapse;margin-top: 5px;margin-bottom: 5px;border:1px solid #000;width: 100%">
					<thead>
						<tr>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">شماره قسط</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ سررسید</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">تاریخ پرداخت</th>
							<th style="padding: 3px;text-align: center;font-size: 9pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">مبلغ پرداختی</th>
							<th style="padding: 3px;text-align: center;font-size: 9pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">زودکرد</th>
							<th style="padding: 3px;text-align: center;font-size: 9pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">دیرکرد</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">پیگیری</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">شماره کارت</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">نقدی</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">واریزی</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;border-left: 1px solid #000;">POS</th>
							<th style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px solid #000;">توضیحات</th>
						</tr>
					</thead>
					<tbody>
						<tr style="" v-for="(payment, index) in userLoan.loanPayments" :key="payment.id">
							<td style="padding: 3px 10px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;">{{ String(index + 1).toPersianDigits() }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ payment.targetMonth_Persian.date.toPersianDigits() }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ payment.saveDate_Persian.year != 0 ? payment.saveDate_Persian.date.toPersianDigits() : '' }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ String(payment.amount || '').toPriceFormat().toPersianDigits() }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ payment.delayDay < 0 ? String(payment.delayDay).toPersianDigits() : '' }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;overflow: hidden;">{{ payment.delayDay > 0 ? String(payment.delayDay).toPersianDigits() : '' }}</td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;border-left: 1px solid #000;"></td>
							<td style="padding: 3px;text-align: center;font-size: 10pt;border-bottom: 1px dashed #000;"></td>
						</tr>
					</tbody>
				</table>
			</div>

			<div style="text-align: right;margin-bottom: 0px;">
				<!-- <div style="font-size: 12pt;margin-bottom: 5px">* لطفا قبل از پرداخت آخرین قسط با شماره های تلفن دفتر تماس بگیرید</div> -->
				<div style="font-size: 9pt;margin-bottom: 5px">* در صورت عدم ارسال و ثبت اطلاعات رسید واریزی پیگیری آن به عهده مشتری می باشد.</div>
				<div style="font-size: 9pt;margin-bottom: 5px">* از قبض های واریزی پس از یادداشت نام و نام خانوادگی و شماره قرارداد عکس گرفته و در واتساپ و یا ایتا به شماره همراه ۰۹۱۷۷۸۸۸۶۶۳ ارسال نمایید. در صورت عدم دسترسی به واتساپ یا ایتا اطلاعات واریزی خود را به صورت تلفنی یا پیامکی به شماره فوق اعلام نمایید.</div>
				<div style="font-size: 9pt;margin-bottom: 5px">* عکس یا اصل رسیدهای واریزی اقساط را نگهداری نمایید و اطلاعات پرداختی خود را در جدول فوق ثبت نمایید.</div>
				<div style="font-size: 9pt;margin-bottom: 5px">
					* لطفا جهت واریز اقساط یا تسویه قرارداد از کارت دیگران استفاده ننمایید.
					&nbsp;
					* یک هفته پس از تسویه حساب با درخواست مشتری، طلا تحویل مشتری می گردد.
				</div>
				<div style="font-size: 9pt;margin-bottom: 5px"></div>
				<!-- <div style="font-size: 9pt;margin-bottom: 5px">* شماره شبای حساب بانک مهر ایران: IR۷۸۰۶۰۰۴۸۳۱۷۰۰۰۱۱۷۶۸۵۷۰۰۱ بنام احمد سیف زاده</div> -->
			</div>

			<div style="display: flex;width: 100%;">
				<div style="width: 45%;display: flex;justify-content: center;align-items: center;">
					<div style="border: 1px solid #000;width: 250px;">
						<div style="border-bottom: 1px solid #000;text-align: center;padding: 3px;font-size: 11pt;">مشخصات خریدار</div>
						<div style="text-align: right;font-size: 10pt;">
							<div style="border-bottom: 1px solid #000;display: flex;width: 100%;">
								<div style="border-left: 1px solid #000;text-align: right;padding: 3px;width: 50%;font-weight: bold;">نام و نام خانوادگی</div>
								<div style="text-align: right;padding: 3px;width: 50%;font-weight: bold;">شماره تماس</div>
							</div>
							<div style="border-bottom: 1px solid #000;display: flex;width: 100%;">
								<div style="border-left: 1px solid #000;text-align: right;padding: 3px;width: 50%;">{{ userLoan.memberModel.fullName }}</div>
								<div style="text-align: right;padding: 3px;width: 50%;">{{ userLoan.memberModel.phone }}</div>
							</div>
							<div style="border-bottom: 1px solid #000;display: flex;width: 100%;">
								<div style="border-left: 1px solid #000;text-align: right;padding: 3px;width: 50%;font-weight: bold;">فرزند</div>
								<div style="text-align: right;padding: 3px;width: 50%;font-weight: bold;">شغل</div>
							</div>
							<div style="border-bottom: 1px solid #000;display: flex;width: 100%;">
								<div style="border-left: 1px solid #000;text-align: right;padding: 3px;width: 50%;">{{ userLoan.memberModel.fatherName }}</div>
								<div style="text-align: right;padding: 3px;width: 50%;">-</div>
							</div>
							<div style="border-bottom: 1px solid #000;display: flex;width: 100%;">
								<div style="border-left: 1px solid #000;text-align: right;padding: 3px;width: 50%;font-weight: bold;">کد ملی</div>
								<div style="text-align: right;padding: 3px;width: 50%;font-weight: bold;">شماره همراه</div>
							</div>
							<div style="border-bottom: 1px solid #000;display: flex;width: 100%;">
								<div style="border-left: 1px solid #000;text-align: right;padding: 3px;width: 50%;">{{ userLoan.memberModel.nationalCode }}</div>
								<div style="text-align: right;padding: 3px;width: 50%;">{{ userLoan.memberModel.mobile }}</div>
							</div>
							<div style="border-bottom: 1px solid #000;text-align: right;padding: 3px;font-weight: bold;">آدرس</div>
							<div style="text-align: right;padding: 3px;">{{ userLoan.memberModel.address }}</div>
						</div>
					</div>
				</div>
				<div style="margin-right: 100px; margin-top:75px; width: 53%;transform: rotate(-90deg);transform-origin: center center">
					<div style="font-size: 14pt; margin-bottom: 40px;">تعداد .... برگ فاکتور دارد.</div>
					<div style="display: flex;justify-content: end;width: 100%;margin-bottom: 10px;">
						<div style="width: 50%;">
							<div style="font-size: 13pt;text-align: center;border-bottom: 1px solid #ddd;">
								<div style="margin-bottom: 15px;">
									{{ userLoan.memberModel.fullName }}
								</div>
								<div>
									{{ String(userLoan.code).toPersianDigits() }}
									<div style="font-size: 10px;">({{ userLoan.loanModel.title }})</div>
								</div>
							</div>
							<div style="font-size: 13pt;text-align: center;margin-top: 10px;">
								{{ userLoan.startDate_Persian.date.toPersianDigits() }}
							</div>
						</div>
					</div>
					<div style="font-size: 10pt;text-align: justify;line-height: 20px;margin-bottom: 10px;">
						اینجانب {{ userLoan.memberModel.fullName }} کلیه طلاهای قرارداد {{ String(userLoan.code).toPersianDigits() }} <span style="font-size: 10px;">({{ userLoan.loanModel.title }})</span> را دریافت نمودم، ضمنا رسید طلای خود را مفقود کرده ام که در صورت یافتن در اسرع وقت تحویل دفتر آقای سیف زاده خواهم داد.
					</div>
					<div style="font-size: 10pt;text-align: left;padding-left: 30px;">
						{{ userLoan.memberModel.fullName }}
					</div>
				</div>
			</div>

			<div style="margin-top: 225px;border: 2px solid #000;padding: 3px;">
				<div style="border-bottom: 2px solid #000">
					<div style="font-size: 10px;line-height: 25px;">
						طلای قرارداد شماره {{ String(userLoan.code).toPersianDigits() }} <span style="font-size: 10px;">({{ userLoan.loanModel.title }})</span> در مورخه {{ new Date().toLocaleDateString('fa-IR').toString().toPersianDigits() }} توسط همکار {{ currentUser }} همکار محسن سیف زاده به شرح
						طلای مشروحه زیر از آقای/خانم {{ userLoan.memberModel.fullName }} تحویل گرفته شد. ضمنا چنانچه به هر دلیل خریدار اقساط خود را به موقع
						پرداخت ننماید فروشنده می تواند با فروش طلای خریدار طلب خود را به صورت یکجا وصول نماید.
					</div>
					<div style="padding: 10px;font-size: 10px;">
						<div v-for="assur in assurances.filter(x => x.assuranceType === 4)" :key="assur.id" style="white-space:pre-line;line-height: 25px;font-size: 10px;">
							<span v-if="assur.coinType !== 0">{{ String(assur.goldWeight || '1').toPersianDigits() }} عدد {{coinTypes.find(x => x.id == assur.coinType).title}}</span>
							<span v-if="assur.coinType !== 0 && assur.description">{{ ' (' }}</span>
							{{ (assur.description || '').toPersianDigits() }}
							<span v-if="assur.coinType !== 0 && assur.description">{{ ')' }}</span>
						</div>
						<div>توضیحات:</div>
						<div style="text-align: center;">
							<span style="margin: 0 15px;">
								وزن طلا: به عدد {{ sumGoldWeights() }} گرم
							</span>
							<span style="margin: 0 15px;">
								مبلغ بدهی {{ userLoan.payableAmount.toString().toPriceFormat().toPersianDigits() }} تومان
							</span style="margin: 0 15px;">
							<span>بابت خرید: خرید طلا</span>
						</div>
						<div style="text-align: right;margin-top: 30px;margin-bottom: 15px;">
							لطفا کلیه طلاهای اینجانب {{ userLoan.memberModel.fullName }} را تحویل حامل رسید آقای/خانم {{ `${userLoan.memberModel.familiar1FirstName} ${userLoan.memberModel.familiar1LastName}` }} با شماره ملی {{ userLoan.memberModel.familiar1Mobile }} موکل دهید
						</div>
						<div style="display: flex;justify-content: center;font-size: 12px;font-weight: bold;margin-bottom: 30px;">
							<span style="margin: 0 15px;">امضا فروشنده</span>
							<span style="margin: 0 15px;">نام و امضا و اثر انگشت خریدار</span>
						</div>
					</div>
				</div>
				<div style="padding: 5px;padding-bottom: 20px;">
					<div style="font-size: 14px;margin-right: 20px;">مشتری گرامی:</div>
					<div style="font-size: 12px;padding-right: 5px;padding-right: 5px;">
						<ul style="list-style-type: circle">
							<li>در صورتی که هر یک از قراردادهای مربوط به شما اقساط معوقه داشته باشد، تحویل طلا و محاسبه تخفیف جهت سایر قراردادها و با قرض و ... انجام نمی گردد.</li>
							<li>جهت دریافت طلا و محاسبه تخفیف ساعت ۹:۰۰ صبح الی ۱۵ عصر با شماره تماس ۰۹۱۷۷۸۸۸۶۶۳ تماس بگیرید.</li>
							<li>پس از پرداخت کل بدهی و دریافت رسیدهای پرداختی و رویت مدرک معتبر شناسایی طلا تحویل خریدار خواهد گردید.</li>
							<li>به ازای هر روز تاخیر در پرداخت اقساط بایستی اقساط بعدی را به همان تعداد روز زودتر پرداخت نمایید.</li>
						</ul>
					</div>
				</div>
			</div>

			<div style="display: flex;margin-top: 180px;">
				<div style="width: 50%;border-left: 1px solid #000;padding-left: 20px;">
					<div style="border: 2px solid #000;font-size: 9px;">
						<div style="padding: 5px;border-bottom: 2px solid #000;">
							<div style="text-align: center;">بسمه تعالی</div>
							<div style="display:flex;justify-content: space-between;">
								<div>سریال {{ '' }}</div>
								<div>{{ '' }}</div>
							</div>
							<div style="text-align: justify;">
								در مورخه {{ new Date().toLocaleDateString('fa-IR').toString().toPersianDigits() }} توسط {{ currentUser }} همکار محسن سیف زاده طلای مشروحه زیر از آقای/خانم
								{{ userLoan.memberModel.fullName }} تحویل گرفته شد.
							</div>
							<div style="min-height: 220px;">
								<div v-for="assur in assurances.filter(x => x.assuranceType === 4)" :key="assur.id" style="white-space:pre-line;line-height: 25px;font-size: 10px;">
									<span v-if="assur.coinType !== 0">{{ String(assur.goldWeight || '1').toPersianDigits() }} عدد {{coinTypes.find(x => x.id == assur.coinType).title}}</span>
									<span v-if="assur.coinType !== 0 && assur.description">{{ ' (' }}</span>
									{{ (assur.description || '').toPersianDigits() }}
									<span v-if="assur.coinType !== 0 && assur.description">{{ ')' }}</span>
								</div>
							</div>
						</div>
						<div style="border-bottom: 2px solid #000;padding:10px 5px;">
							<div style="text-align: center;">
								وزن طلا: به عدد {{ sumGoldWeights() }} گرم
							</div>
							<div style="margin: 5px 0;">شماره قرارداد: {{ userLoan.code.toString().toPersianDigits() }} <span style="font-size: 10px;">({{ userLoan.loanModel.title }})</span></div>
							<div style="margin: 5px 0;">مبلغ بدهی: {{ userLoan.payableAmount.toString().toPriceFormat().toPersianDigits() }}</div>
							<div style="margin: 5px 0;">وکالت تحویل طلا به {{ `${userLoan.memberModel.familiar1FirstName} ${userLoan.memberModel.familiar1LastName}` }}</div>
						</div>
						<div style="display: flex;">
							<div style="width: 50%;border-left: 2px solid #000;padding: 20px 0;text-align: center;">
								امضا تحویل گیرنده:
								<br />
								{{ currentUser }} همکار محسن سیف زاده
							</div>
							<div style="width: 50%;padding: 20px 0;text-align: center;">
								امضا تحویل دهنده:
								<br />
								{{ userLoan.memberModel.fullName }}
							</div>
						</div>
					</div>
				</div>
				<div style="width: 50%;padding-right: 20px;">
					<div style="border: 2px solid #000;font-size: 9px;">
						<div style="padding: 5px 5px 0;">شماره قرارداد: {{ userLoan.code.toString().toPersianDigits() }} <span style="font-size: 10px;">({{ userLoan.loanModel.title }})</span></div>
						<div style="padding: 5px;border-bottom: 2px solid #000;text-align: justify;line-height: 18px;height: 350px;">
							<div style="font-size: 12px;text-align: justify; padding: 10px; line-height: 25px;">
								اینجانب <span style="font-weight: bold;">{{ userLoan.memberModel.fullName }}</span> فرزند <span style="font-weight: bold;">{{ userLoan.memberModel.fatherName }}</span>
								مقدار <span style="font-weight: bold;">{{ sumGoldWeights() }} گرم طلا </span> بابت تعهد پرداخت اقساط این قرارداد نزد آقای سیف زاده به عنوان رهن
								قرار داده ام و متعهد می گردم مبلغ اقساط خود را در تاریخ سررسید اقساط پرداخت نمایم.
								<br />
								مبلغ ({{ userLoan.amount.toString().toPriceFormat().toPersianDigits() }} تومان) به شماره حساب {{ bankAccountNumber().toPersianDigits() }} بانک {{ bankName() }}
								به نام {{ userLoan.memberModel.fullName }} واریز نمایید.
								<div v-for="assur in assurances.filter(x => x.assuranceType === 4)" :key="assur.id" style="white-space:pre-line;line-height: 20px;font-size: 11px;">
									<span v-if="assur.coinType !== 0">{{ String(assur.goldWeight || '1').toPersianDigits() }} عدد {{coinTypes.find(x => x.id == assur.coinType).title}}</span>
									<span v-if="assur.coinType !== 0 && assur.description">{{ ' (' }}</span>
									{{ (assur.description || '').toPersianDigits() }}
									<span v-if="assur.coinType !== 0 && assur.description">{{ ')' }}</span>
								</div>
							</div>
						</div>
						<div style="display: flex;">
							<div style="width: 50%;border-left: 2px solid #000;padding: 20px 0;text-align: center;">
								امضا فروشنده
								<br />
								{{ currentUser }} همکار محسن سیف زاده
							</div>
							<div style="width: 50%;padding: 20px 0;text-align: center;">
								امضا و ضرب انگشت خریدار: آقا/خانم
								<br />
								{{ userLoan.memberModel.fullName }}
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { sumBy } from 'lodash'

	export default {
		name: 'UserLoanPrint',
		components: {
		},
		props: {
			userLoanId: {
				type: String,
			}
		},
		data: () => ({
			html: '',
			userLoan: null,
			assurances: [],
			coinTypes: [{ id: 0, title: '-' }, { id: 1, title: 'ربع سکه' }, { id: 2, title: 'نیم سکه' }, { id: 3, title: 'تمام بهار' }, { id: 4, title: 'گرمی پارسیان و ...' }],
		}),
		mounted() {
			this.fillHtml()
		},
		computed: {
			...get('siteConfig', [
				'fullTitle'
			]),
			...get('appSettings', [
				'settings'
			]),
			...get('auth', [
				'getCurrentUser',
			]),
			businessTitle() {
				return this.settings?.businessTitle || this.fullTitle
			},
			currentUser() {
				var user = this.getCurrentUser
				if (user && user.userData) { return `${user.userData.fullName}` }
				return ''
			}
		},
		methods: {
			fillHtml() {
				this.getUserLoan().then(res => {
					this.userLoan = res
					this.loadAssurances().then(res2 => {
						this.assurances = res2
						this.$nextTick(() => {
							this.$emit('ready')
						})
					})
				})
				// this.html = `مدیریت محترم حسابداری <span style="font-weight:bold">اداره مورد نظر</span>\r\nبا سلام و احترام،`
			},
			getUserLoan() {
				return api.get('admin/userLoan/get/' + this.userLoanId)
					.catch(err => {
						toast.error(err.message)
					})
			},
			loadAssurances() {
				return api.get('admin/Assurance/ListByUserLoanId/' + this.userLoanId + '/false', null)
					.catch(err => {
						toast.error(err.message)
					})
			},
			sumGoldWeights() {
				return sumBy(this.assurances.filter(x => x.assuranceType === 4 && x.coinType === 0), x => x.goldWeight).toString().toPersianDigits()
			},
			bankAccountNumber() {
				let bankAccounts = JSON.parse(this.userLoan.memberModel.bankAccounts || '[]')
				return bankAccounts.length ? bankAccounts[0].accountNumber : '-'
			},
			bankName() {
				let bankAccounts = JSON.parse(this.userLoan.memberModel.bankAccounts || '[]')
				return bankAccounts.length ? bankAccounts[0].bank : '-'
			}
		}
	}
</script>
<style scoped></style>